export default __webpack_public_path__ + "static/media/rent.d110b332.jpg";